import { FC } from 'react';
import dynamic from 'next/dynamic';
import {
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalCloseButton,
  ModalBody,
  ModalContent,
  UseModalProps,
  Flex,
} from '@chakra-ui/react';
import { MhyFormButton } from '../types';
import { useTranslation } from '../lib/hooks.context';

/*
 * Renders a button with onClick that triggers a modal where a form is rendered. The rendered form is based on 'form' prop
 */

const Forms = dynamic(() => import('./Forms'));

const FormModal = ({
  form,
  ...modalProps
}: Pick<MhyFormButton, 'form'> & UseModalProps) => {
  const t = useTranslation();

  return (
    <Modal {...modalProps}>
      <ModalOverlay />
      <ModalContent maxWidth="container.md">
        <ModalCloseButton />
        <ModalBody minHeight="300px" as={Flex} flexDirection="column">
          {modalProps?.isOpen ? (
            <Forms {...form}>
              {(closeButtonProps) => (
                <Button {...closeButtonProps} onClick={modalProps.onClose}>
                  {t('close')}
                </Button>
              )}
            </Forms>
          ) : null}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

const FormModalButton: FC<MhyFormButton> = ({ form, ...buttonProps }) => {
  const { onOpen, isOpen, onClose } = useDisclosure();

  return (
    <>
      <Button {...buttonProps} onClick={onOpen} />
      <FormModal form={form} isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default FormModalButton;
